import { render, staticRenderFns } from "./newComManagementCreate.vue?vue&type=template&id=a56edb8e&scoped=true"
import script from "./newComManagementCreate.vue?vue&type=script&lang=js"
export * from "./newComManagementCreate.vue?vue&type=script&lang=js"
import style0 from "./newComManagementCreate.vue?vue&type=style&index=0&id=a56edb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56edb8e",
  null
  
)

export default component.exports